import { Box, Stack, Typography } from "@mui/material";
import React from "react";

const SearchedBookCard = ({ book }) => {
  return (
    <Stack
      direction={"row"}
      gap={2}
      sx={{
        display: "flex",
        alignItems: "center",
        backgroundColor: "#1373E511",
        border: "1px solid #1373E533",
        borderRadius: "8px",
        p: "12px",
        width: "fit-content",
        minWidth: 260,
      }}
    >
      <Box>
        <img
          src={book?.image || "/image-placeholder.jpeg"}
          alt={book?.title || "Book Cover"}
          style={{
            width: "60px",
            height: "60px",
            borderRadius: "10%",
            objectFit: "cover",
          }}
        />
      </Box>
      <Box>
        <Typography sx={{ fontWeight: 600, fontSize: "15px" }}>
          {book?.title || "-"}
        </Typography>
        <Stack direction="row" gap={2} mt={0.5}>
          <Box>
            <Typography sx={{ fontWeight: 500, fontSize: "12px" }}>
              Author: {book?.author || "--"}
            </Typography>
            <Typography sx={{ fontWeight: 500, fontSize: "12px" }}>
              Publisher: {book?.publisher || "--"}
            </Typography>
          </Box>
        </Stack>
      </Box>
    </Stack>
  );
};

export default SearchedBookCard;
